import { DisciplineResults } from '../../Components/DisciplineResults';

export const CowboySilhouetteResults = () => {
  return (
    <DisciplineResults 
      discipline="COWBOY_SILHOUETTE" 
      disciplineName="Cowboy Silhouette"
    />
  );
};
